<div class="mb-6 flex items-center justify-between">
  <h1 class="textTabsColor text-2xl font-bold" i18n="@@adminApprovedPharmacies">Pharmacies</h1>
</div>

<app-approved-ph-table
  [view]="isTeleSales() ? 'telesales' : 'admin'"
  [pharmacies]="pharmacies()"
  [state]="state()"
  [isFiltersApplied]="isFiltersApplied()"
  [currentPage]="currentPage()"
  [totalItems]="totalItems()"
  [itemsPerPage]="itemsPerPage()"
  [totalPages]="totalPages"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  (rowClick)="navigateToDetails($event)"
  (assignSuccess)="onAssignSuccess($event)"
  (followUp)="followUpPharmacy.set($event)">
  @if (isTeleSales()) {
    <app-approved-ph-telesales-filters
      [filters]="filters()"
      (toggleSortOrder)="toggleSortOrder()"
      (applyFilters)="applyFilters($event)"
      (resetFilters)="resetFilters()" />
  } @else {
    <app-approved-ph-filters
      [filters]="filters()"
      [segments]="segments()"
      (toggleSortOrder)="toggleSortOrder()"
      (resetFilters)="resetFilters()"
      (applyFilters)="applyFilters($event)"
      (selectFullName)="selectPharmacyOwner($event)"
      (selectEmployee)="selectEmployee($event)" />
  }
</app-approved-ph-table>

@if (followUpPharmacy(); as pharmacy) {
  <app-follow-up-dialog
    [pharmacyId]="pharmacy.id"
    (closed)="followUpPharmacy.set(null)"
    (saved)="onFollowUpSaved()" />
}
